import { Component, EventEmitter, OnInit, OnChanges, OnDestroy, Input, Output } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Message } from '../../../shared/entities/message';
import { User } from '../../../shared/entities/user';
import { Panic } from '../../../shared/entities/panic';
import { PanicService } from '../../../shared/services/panic.service';
import { NotificationAlert } from '../../../shared/entities/notification-alert';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { MatSnackBar } from '@angular/material';
import { Tracker } from '../../../shared/entities/tracker';
import { TrackerService } from '../../../shared/services/tracker.service';
import { DriverService } from '../../../shared/services/driver.service';
import { Driver } from '../../../shared/entities/driver';

declare var require: any;

@Component({
    selector: 'notification-alert',
    styles: [require('./notification-alert.component.css')],
    template: require('./notification-alert.component.html'),
    animations: [
        trigger('notificationState', [
        state('void', style({
            'height': '0px',
            'width': '0px',
            'right': '0',
            'border': '0px'
        })),
        state('open',   style({
            'right': '10pt',
            'top': '51px',
            'width': '650px',
            'bottom': '300px',
            'overflow': 'auto'
        }))
            //,
        //transition('void => *', animate('300ms ease-in')),
        //transition('* => void', animate('300ms ease-out'))
        ])
    ]
})

export class NotificationAlertComponent implements OnInit, OnChanges, OnDestroy {

    public notificationState:string;

    public isShowingOutOfRoute:boolean = false;

    @Output()
    public onClickClosePanic : EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output()
    public onClickDisablePanicNotify : EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor (public authenticationService:AuthenticationService,
                public notificationService: NotificationService,
                public trackerService:TrackerService,
                public driverService:DriverService,
                public snackBar: MatSnackBar) {
        
    }

    public ngOnInit (): void {
        
    }
    
    public ngOnDestroy (): void {
    }

    public ngOnChanges(): void {
    }

    private onClickClose():void {
        this.isShowingOutOfRoute = false;
        this.notificationState = 'void';
    }
    private onClickShow(isShowingOutOfRoute:boolean) {
        this.isShowingOutOfRoute = isShowingOutOfRoute;
        this.notificationState = 'open';
    }

    private onClickDisableNotify():void {
        this.onClickDisablePanicNotify.emit();
    }

    private onClickSolveNotification(notification:NotificationAlert):void {
        //this.notificationService.deactivateNotification(this.authenticationService.userLogged.token, notification)
                
    }
    
    onClickDeactivate(notification:NotificationAlert) {
        this.authenticationService.isLoading = true;
        this.notificationService.deactivateNotification(this.authenticationService.userLogged.token, notification)
            .subscribe(
                x => { 
                    this.authenticationService.isLoading = false;
                    this.openSnackBar('Notificação desativada com sucesso.', false);            
                    for (var i = 0; i < this.notificationService.notifications.length; i++) {
                        if (this.notificationService.notifications[i].id == notification.id) {
                            this.notificationService.notifications.splice(i, 1);
                            return;
                        }
                    }
                    //SE não está no array acima, procura no array de desvio de rotas
                    for (var i = 0; i < this.notificationService.notificationsOutOfRoute.length; i++) {
                        if (this.notificationService.notificationsOutOfRoute[i].id == notification.id) {
                            this.notificationService.notificationsOutOfRoute.splice(i, 1);
                            return;
                        }
                    }  
                },
                error =>  {
                    this.openSnackBar('Erro ao tentar desativar notificação.', true);
                    this.authenticationService.isLoading = false;
            });            
    }


    public openSnackBar(msg:string, isError:boolean) {
        if (isError) {
            this.snackBar.open(msg, null, { duration: 2500, panelClass: 'snackbar-panel-error' });
        } else {
            this.snackBar.open(msg, null, {
                duration: 3500,
            });
        }
    }

    public onActiveSound(actived:boolean) {
        this.notificationService.isSoundActive = actived;
        if (actived) {
            this.openSnackBar('Alerta sonoro de desvio de rota ativado!', false);
        } else {
            this.openSnackBar('Alerta sonoro de desvio de rota desativado!', false);

        }
    }

    private getTrackerById(id:number):Tracker
    {
        if (this.trackerService.customers) 
        {
            for (let customer of this.trackerService.customers) 
            {
                for (let tracker of customer.trackers) 
                {
                    if (tracker.id == id) {
                        return tracker;
                    }
                }
            }
        }
    }
    
    private getDriverById(id:number):Driver
    {
        if (this.driverService.drivers) 
        {
            for (let driver of this.driverService.drivers) 
            {
                if (driver.id == id) {
                    return driver;
                }
            }
        }
    }
        
    formatDateTime(date:Date):string {
        if ( !date || (date && !date.getDate()) ) { return; }
        
        var dd:number = date.getDate();
        var month:number = date.getUTCMonth() + 1;
        var yy:number = date.getFullYear();
        var hh:number = date.getHours() + 3;
        
        if (hh == 24) {
            hh = 0;
        } else if (hh > 24) {
            dd += 1;
            hh = hh - 24;
        }

        var mm:number = date.getMinutes();
        return ('00' + dd).slice(-2) + '/'+ ('00' + month).slice(-2) + '/' + yy + ' - ' + ('00' + hh).slice(-2) + ':' + ('00' + mm).slice(-2) + 'h';
    }

    formatDate(date:Date):string {
        if ( !date || (date && !date.getDate()) ) { return; }
        
        var dd:number = date.getDate();
        var month:number = date.getUTCMonth() + 1;
        var yy:number = date.getFullYear();
   
        return ('00' + dd).slice(-2) + '/'+ ('00' + month).slice(-2) + '/' + yy;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/core/components/notification/notification-alert.component.ts